
const figures = document.querySelector('[data-home-feature-figures]');
const contents = document.querySelector('[data-home-feature-contents]');
const rtl = (document.querySelector('html').getAttribute('dir') == 'rtl');

function initSlider() {
  if(!figures || !contents) return;

  $(figures).slick({
    speed: 1000,
    slidesToShow: 1,
    infinite: true,
    autoplay: false,
    arrows: false,
    dots: false,
    rtl,
    asNavFor:'[data-home-feature-contents]'
  })

  $(contents).slick({
    speed: 1000,
    slidesToShow: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: true,
    vertical: true,
    draggable: false,
    swipeToSlide: false,
    asNavFor:'[data-home-feature-figures]',
    customPaging: function(slider, i) {
      return $('<span class="pagidot" />').text(i + 1);
    }
    ,responsive: [
    {
      breakpoint: 739,
      settings: {
        vertical: false,
        adaptiveHeight: true
      }
    }]
  })

}

export default initSlider



// WEBPACK FOOTER //
// ./public/javascripts/modules/home-features.js